import React, { useState, useCallback, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { getAuth } from "firebase/auth";
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/react';
import LoadingSpinner from "../LoadingSpinner";
import { ReactComponent as ClipIcon } from '../../assets/icons/ClipIcon.svg';
import { ReactComponent as DropArrow } from '../../assets/icons/DropArrow.svg';
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getStorage, ref, listAll, getMetadata, getDownloadURL } from "firebase/storage";
import { ReactComponent as ContractIcon } from '../../assets/icons/ContractIcon.svg';
import { ReactComponent as AIcon } from '../../assets/icons/AIcon.svg';
import { ReactComponent as BIcon } from '../../assets/icons/BIcon.svg';
import { ReactComponent as CIcon } from '../../assets/icons/CIcon.svg';
import { ReactComponent as EIcon } from '../../assets/icons/EIcon.svg';
import { ReactComponent as RIcon } from '../../assets/icons/RIcon.svg';
import { ReactComponent as XIcon } from '../../assets/icons/XIcon.svg';
const RepositorioModal = ({ show, archivo, archivoForm, handleChange, handleSubmit, onClose, subiendo, handleTipoChange, opcionesTipoFactura }) => {
if (!show) return null;
return (
<div className="biblioteca-modal-backdrop">
<div className="biblioteca-modal-content">
<button
onClick={onClose}
className="biblioteca-modal-close-btn"
>
<p className="biblioteca-modal-close-icon">&times;</p>
</button>
<h2 className="biblioteca-modal-title">
Subí una factura al Repositorio
</h2>
{archivo && (
<p style={{ fontSize: "14px", color: "#666", width: '87%', overflow: "hidden",
textOverflow: "ellipsis",
whiteSpace: "nowrap", margin: '0 auto 20px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
<ClipIcon style={{ height: '15px', margin: 'auto 0', overflow: 'visible' }} /> <b style={{ overflow: "hidden",
textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: '15px', fontFamily: 'Effra', fontWeight: 'normal', color: '#2c2c2c' }}>{archivo.name}</b>
</p>
)}
<form onSubmit={handleSubmit} className="biblioteca-modal-form">
<div className="biblioteca-form-group" style={{}}>
<Listbox value={archivoForm.tipo} onChange={handleTipoChange}>
{({ open }) => (
<>
<ListboxButton className={`doc-listbox-button ${open ? 'open' : ''}`}>
{archivoForm.tipo.name}
<span className="doc-arrow-container">
<span className="doc-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="doc-listbox-options">
{opcionesTipoFactura.map((op) => (
<ListboxOption key={op.id} value={op} className="doc-listbox-option">
{op.name}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className="biblioteca-form-group">
<input
type="text"
id="titulo"
name="titulo"
value={archivoForm.titulo}
onChange={handleChange}
placeholder="Título"
className="biblioteca-form-input"
required
/>
</div>
<div className="biblioteca-form-group">
<input
type="text"
id="parte_interesada"
name="parte_interesada"
value={archivoForm.parte_interesada}
onChange={handleChange}
placeholder="Nombre de la parte interesada"
className="biblioteca-form-input"
/>
</div>
<div className="biblioteca-modal-actions">
<button
type="submit"
className="biblioteca-submit-btn"
disabled={subiendo}
>
{subiendo ? "Subiendo..." : "Compartir"}
</button>
</div>
</form>
</div>
</div>
);
};
const FacturaCard = ({ factura, isRecentCard }) => {
const handleCardClick = async (e) => {
e.preventDefault();
try {
const storage = getStorage();
const facturaRef = ref(storage, factura.nombre);
const url = await getDownloadURL(facturaRef);
if (url) {
window.open(url, '_blank');
} else {
alert("No se pudo obtener la URL de la factura.");
}
} catch (error) {
console.error("Error al obtener la URL de la factura:", error);
alert("Error al intentar abrir el documento.");
}
};
const getCleanFileName = (fullPath) => {
const fileNameWithExtension = fullPath.split('/').pop();
const fileNameWithoutExtension = fileNameWithExtension.split('.')[0];
let cleanName = fileNameWithoutExtension;
if (fileNameWithoutExtension.startsWith('factura_')) {
cleanName = fileNameWithoutExtension.substring('factura_'.length);
}
return cleanName.replace(/_/g, ' ');
};
const getDocumentIcon = (factura, isRecentCard) => {
const iconStyle = {
height: isRecentCard ? "18px" : "28px",
overflow: 'visible',
marginTop: '3px'
};
if (factura.tipo === 'contrato') {
return <ContractIcon style={iconStyle} />;
}
const fileName = getCleanFileName(factura.nombre);
const firstLetter = fileName.toUpperCase().charAt(0);
switch (firstLetter) {
case 'A':
return <AIcon style={iconStyle} />;
case 'B':
return <BIcon style={iconStyle} />;
case 'C':
return <CIcon style={iconStyle} />;
case 'E':
return <EIcon style={iconStyle} />;
case 'R':
return <RIcon style={iconStyle} />;
case 'X':
return <XIcon style={iconStyle} />;
default:
return <ContractIcon style={iconStyle} />;
}
};
const displayFileName = getCleanFileName(factura.nombre);
return (
<a
href="#"
onClick={handleCardClick}
target="_blank"
style={{ textDecoration: 'none', padding: '0' }}
rel="noopener noreferrer"
className={`document-card ${isRecentCard ? "biblio-recent-card" : "all-card"}`}
>
<div>
{getDocumentIcon(factura, isRecentCard)}
<div className="card-content" style={{ gap: '0' }}>
<span style={{
display: "inline-block",
maxWidth: "220px",
overflow: "hidden",
textOverflow: "ellipsis",
whiteSpace: "nowrap",
textAlign: "left",
fontSize:'14px',
margin: 0,
}} className="doc-id">{displayFileName}</span>
<p className="card-autor" style={{fontSize:'14px',}}>{factura.parte_interesada}</p>
</div>
</div>
</a>
);
};

const Repositorio = () => {
// --- ESTADOS Y OPCIONES (NO CAMBIAN) ---
const [subiendo, setSubiendo] = useState(false);
const [mensaje, setMensaje] = useState("");
const [listaFacturas, setListaFacturas] = useState([]);
const [facturasRecientes, setFacturasRecientes] = useState([]);
const [cargandoFacturas, setCargandoFacturas] = useState(true);
const [showFacturaModal, setShowFacturaModal] = useState(false);
const [archivoSeleccionado, setArchivoSeleccionado] = useState(null);
const [filtroSeleccionado, setFiltroSeleccionado] = useState('todos');
const [ordenamientos, setOrdenamientos] = useState({
contratos: 'recientes',
facturasVenta: 'recientes',
facturasCompra: 'recientes',
});
const [facturaForm, setFacturaForm] = useState({
titulo: "",
parte_interesada: "",
descripcion: "",
tipo: { id: 1, name: "Factura de venta", value: "factura_venta" }
});
const opcionesTipoFactura = [
{ id: 1, name: "Factura de venta", value: "factura_venta" },
{ id: 2, name: "Factura de compra", value: "factura_compra" },
{ id: 3, name: "Contrato", value: "contrato" },
];
const opcionesFiltro = [
{ value: 'todos', label: 'Todos' },
{ value: 'contratos', label: 'Contratos' },
{ value: 'factura_venta_A', label: 'Facturas A Venta' },
{ value: 'factura_venta_B', label: 'Facturas B Venta' },
{ value: 'factura_venta_X', label: 'Facturas X Venta' },
{ value: 'factura_compra_A', label: 'Facturas A Compra' },
{ value: 'factura_compra_B', label: 'Facturas B Compra' },
{ value: 'factura_compra_C', label: 'Facturas C Compra' },
{ value: 'factura_compra_X', label: 'Facturas X Compra' },
];
const opcionesOrdenamiento = [
{ value: 'recientes', label: 'Más recientes' },
{ value: 'antiguos', label: 'Más antiguos' },
{ value: 'alfabetico', label: 'A-Z' },
{ value: 'alfabetico_desc', label: 'Z-A' },
];

// --- FUNCIÓN DE CARGA CORREGIDA: SOLO USA FIREBASE CLIENT ---
const cargarFacturasDeRepositorio = useCallback(async () => {
    setCargandoFacturas(true);
    try {
        const auth = getAuth();
        const user = auth.currentUser;
        if (!user) return;

        const db = getFirestore();
        const storage = getStorage();

        // 1. Obtener la Metadata de Firestore (Repositorio)
        const docsRef = collection(db, "repositorio_documentos");
        const snapshot = await getDocs(docsRef);
        
        const metadataMap = new Map();
        snapshot.forEach(doc => {
            const data = doc.data();
            metadataMap.set(data.nombre_archivo, data); 
        });

        // 2. Obtener referencias de archivos de Firebase Storage (Client SDK)
        const CARPETAS_STORAGE = ["facturas/", "facturas_compra/", "contratos/"];
        const listPromises = CARPETAS_STORAGE.map(folder => {
            const folderRef = ref(storage, folder);
            return listAll(folderRef); 
        });

        const results = await Promise.all(listPromises);
        let allItemRefs = [];
        results.forEach(result => {
            // Recopilar todas las referencias de archivos
            allItemRefs.push(...result.items);
        });
        
        // 3. Obtener metadatos de cada archivo de Storage en paralelo
        // Esto es necesario para obtener la fecha de creación (timeCreated)
        const metadataPromises = allItemRefs.map(itemRef => getMetadata(itemRef));
        const allMetadata = await Promise.all(metadataPromises);

        let facturasCompletas = [];

        // 4. Procesar y combinar los resultados
        allItemRefs.forEach((itemRef, index) => {
            const storageMetadata = allMetadata[index]; // Metadata obtenida de Storage
            
            const nombre_archivo_completo = itemRef.fullPath;
            const nombre_archivo_limpio = itemRef.name;
            const folderPrefix = nombre_archivo_completo.split('/')[0];
            
            // Metadata de Firestore tiene prioridad
            const firestoreMetadata = metadataMap.get(nombre_archivo_limpio) || {};
            
            let origen_documento = '';
            if (folderPrefix === 'facturas') origen_documento = 'facturas_venta';
            else if (folderPrefix === 'facturas_compra') origen_documento = 'facturas_compra';
            else if (folderPrefix === 'contratos') origen_documento = 'contratos';
            
            // La fecha de subida: Usar Firestore, si no existe, usar Storage.timeCreated (que ahora sí existe)
            // itemRef.timeCreated ya no es undefined, sino storageMetadata.timeCreated
            const fechaSubida = firestoreMetadata.fechaSubida || storageMetadata.timeCreated; 

            facturasCompletas.push({
                nombre: nombre_archivo_completo, 
                origen: origen_documento,
                // YA NO NECESITAMOS .toString() ya que timeCreated ya es un string ISO
                fechaSubida: fechaSubida, 
                // "parte_interesada" es la contraparte del documento (proveedor,
                // cliente) cuando alguien la completó al subirlo. Si quedó vacía,
                // se muestra igual quién lo subió (siempre conocido: requiere
                // login) en vez de un genérico "Autor Desconocido".
                parte_interesada: firestoreMetadata.parte_interesada
                    || firestoreMetadata.subidoPorNombre
                    || "Autor Desconocido",
                tipo: firestoreMetadata.tipo || (origen_documento === 'contratos' ? 'contrato' : 'factura'),
                titulo: firestoreMetadata.titulo || "Título Desconocido",
            });
        });

        // 5. Filtrar y ordenar
        const facturasOrdenadas = facturasCompletas.sort(
            (a, b) => new Date(b.fechaSubida) - new Date(a.fechaSubida)
        );
        
        setListaFacturas(facturasOrdenadas);
        setFacturasRecientes(facturasOrdenadas.slice(0, 4));

    } catch (error) {
        setMensaje(`Error al cargar el repositorio: ${error.message}. Revise las reglas de seguridad de Firebase.`);
        console.error("Error al cargar repositorio desde cliente:", error);
    } finally {
        setCargandoFacturas(false);
    }
}, []);

// --- EFECTOS Y HANDLERS (SE MANTIENEN) ---
useEffect(() => {
cargarFacturasDeRepositorio();
}, [cargarFacturasDeRepositorio]);

const onDrop = useCallback((acceptedFiles) => {
if (acceptedFiles.length > 0) {
setArchivoSeleccionado(acceptedFiles[0]);
setShowFacturaModal(true);
}
}, []);
const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
onDrop,
noClick: true,
noKeyboard: true,
});
const handleButtonClick = () => open();

// ESTA FUNCIÓN AÚN USA EL BACKEND (solo para SUBIR)
const handleFacturaModalSubmit = async (e) => {
e.preventDefault();
if (!archivoSeleccionado) {
setMensaje("No hay archivo seleccionado.");
return;
}
setSubiendo(true);
setMensaje("Subiendo factura...");
try {
const auth = getAuth();
const user = auth.currentUser;
if (!user) {
setMensaje("Usuario no logueado.");
setSubiendo(false);
return;
}
const token = await user.getIdToken();
const formData = new FormData();
formData.append("archivo", archivoSeleccionado);
formData.append("titulo", facturaForm.titulo);
formData.append("parte_interesada", facturaForm.parte_interesada);
formData.append("tipo", facturaForm.tipo.value);
const response = await fetch("https://backend-288175208699.europe-west1.run.app/subir-documento", {
method: "POST",
headers: { Authorization: `Bearer ${token}` },
body: formData,
});
const result = await response.json();
if (response.ok) {
setMensaje("Factura subida correctamente.");
cargarFacturasDeRepositorio(); 
setShowFacturaModal(false);
setArchivoSeleccionado(null);
setFacturaForm({
titulo: "",
parte_interesada: "",
descripcion: "",
tipo: { id: 1, name: "Factura de venta", value: "factura_venta" }
});
} else {
setMensaje(`Error: ${result.error}`);
}
} catch (error) {
setMensaje(`Error al subir factura: ${error.message}`);
}
setSubiendo(false);
};

// --- LÓGICA DE FILTRADO Y ORDENAMIENTO (NO CAMBIA) ---
const filtrarDocumentos = () => {
if (filtroSeleccionado === 'todos') {
return listaFacturas;
}
return listaFacturas.filter(doc => {
switch (filtroSeleccionado) {
case 'contratos':
return doc.origen === "contratos";
case 'factura_venta_A':
return doc.origen === "facturas_venta" && doc.nombre.includes('/A-');
case 'factura_venta_B':
return doc.origen === "facturas_venta" && doc.nombre.includes('/B-');
case 'factura_venta_X':
return doc.origen === "facturas_venta" && doc.nombre.includes('/X-');
case 'factura_compra_A':
return doc.origen === "facturas_compra" && doc.nombre.includes('/A-');
case 'factura_compra_B':
return doc.origen === "facturas_compra" && doc.nombre.includes('/B-');
case 'factura_compra_C':
return doc.origen === "facturas_compra" && doc.nombre.includes('/C-');
case 'factura_compra_X':
return doc.origen === "facturas_compra" && doc.nombre.includes('/X-');
default:
return true;
}
});
};
const ordenarDocumentosPorTipo = (documentos, tipoOrdenamiento) => {
switch (tipoOrdenamiento) {
case 'recientes':
return [...documentos].sort((a, b) => new Date(b.fechaSubida) - new Date(a.fechaSubida));
case 'antiguos':
return [...documentos].sort((a, b) => new Date(a.fechaSubida) - new Date(b.fechaSubida));
case 'alfabetico':
return [...documentos].sort((a, b) => a.nombre.localeCompare(b.nombre));
case 'alfabetico_desc':
return [...documentos].sort((a, b) => b.nombre.localeCompare(a.nombre));
default:
return documentos;
}
};
const documentosFiltrados = filtrarDocumentos();
const contratos = listaFacturas.filter(doc => doc.origen === "contratos");
const facturasVenta = listaFacturas.filter(doc => doc.origen === "facturas_venta");
const facturasCompra = listaFacturas.filter(doc => doc.origen === "facturas_compra");
const facturasVentaA = facturasVenta.filter(doc => doc.nombre.includes('/A-'));
const facturasVentaB = facturasVenta.filter(doc => doc.nombre.includes('/B-'));
const facturasVentaX = facturasVenta.filter(doc => doc.nombre.includes('/X-'));
const facturasCompraA = facturasCompra.filter(doc => doc.nombre.includes('/A-'));
const facturasCompraB = facturasCompra.filter(doc => doc.nombre.includes('/B-'));
const facturasCompraC = facturasCompra.filter(doc => doc.nombre.includes('/C-'));
const facturasCompraX = facturasCompra.filter(doc => doc.nombre.includes('/X-'));
const getFiltroLabel = (value) => {
const filtro = opcionesFiltro.find(op => op.value === value);
return filtro ? filtro.label : 'Filtrar por:';
};
const opcionesDisponibles = opcionesFiltro.filter(opcion => {
if (opcion.value === 'todos') {
return true;
}
if (opcion.value === 'contratos') {
return contratos.length > 0;
}
if (opcion.value === 'factura_venta_A') {
return facturasVentaA.length > 0;
}
if (opcion.value === 'factura_venta_B') {
return facturasVentaB.length > 0;
}
if (opcion.value === 'factura_venta_X') {
return facturasVentaX.length > 0;
}
if (opcion.value === 'factura_compra_A') {
return facturasCompraA.length > 0;
}
if (opcion.value === 'factura_compra_B') {
return facturasCompraB.length > 0;
}
if (opcion.value === 'factura_compra_C') {
return facturasCompraC.length > 0;
}
if (opcion.value === 'factura_compra_X') {
return facturasCompraX.length > 0;
}
return false;
});

// --- JSX (NO CAMBIA) ---
return (
<div
{...getRootProps()}
className="Trazabilidad"
style={{
border: isDragActive ? "2px solid #e65c5c" : "2px solid transparent",
}}
>
{/* ... JSX del Repositorio ... */}
{isDragActive && (
<div style={{
position: 'absolute',
top: 0,
left: 0,
right: 0,
bottom: 0,
display: 'flex',
justifyContent: 'flex-end',
alignItems: 'center',
borderRadius: '25px',
flexDirection: 'column',
gap: '10px',
zIndex: 10,
}}>
<DropArrow style={{ height: "25px", overflow: 'visible', marginTop: '3px' }} />
<div style={{ marginBottom: '30px', backgroundColor: '#e65c5c', padding: '20px 0', borderRadius: '100px', width: '300px' }}>
<p style={{
fontSize: '15px',
lineHeight: '20px',
fontFamily: 'Effra',
fontWeight: 'normal',
color: 'white',
maxWidth: '80%',
textAlign: 'center',
margin: 'auto',
cursor: 'default'
}}>
Soltá la factura para agregarla al Repositorio
</p>
</div>
</div>
)}
<input {...getInputProps()} />
<header className="trazabilidad-header">
<div className="header-content">
<h1>Repositorio</h1>
</div>
</header>
{cargandoFacturas ? (
<LoadingSpinner />
) : (
<div className="trazabilidad-content">
<div className="section">
<h2>Recientes</h2>
{facturasRecientes.length > 0 ? (
<div className="recent-grid">
{facturasRecientes.map((factura, index) => (
<FacturaCard key={index} factura={factura} isRecentCard={true} />
))}
</div>
) : (
<p>No hay facturas recientes.</p>
)}
</div>
<div className="todos-archivos-section">
<h2 style={{ fontSize: '17px', fontFamily: 'Effra', fontWeight: 'normal', color: '#555', cursor: 'default' }}>Archivos</h2>
<div style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
<button onClick={handleButtonClick} className="biblioteca-boton">
<ClipIcon style={{ height: '12px', margin: 'auto', overflow: 'visible' }} />Adjuntar un archivo
</button>
{}
<div className="custom-listbox-container">
<Listbox value={filtroSeleccionado} onChange={setFiltroSeleccionado}>
{({ open }) => (
<>
<ListboxButton
className={`custom-listbox-button ${open ? "open" : ""}`}
style={{ minWidth: "200px" }}
>
{filtroSeleccionado === "todos" ? "Filtrar por" : getFiltroLabel(filtroSeleccionado)}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options" >
{opcionesDisponibles.map(opcion => (
<ListboxOption
key={opcion.value}
value={opcion.value}
className="custom-listbox-option"
>
{opcion.label}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
</div>
{filtroSeleccionado === 'todos' ? (
<>
{contratos.length > 0 ? (
<>
<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px', marginTop: '15px' }}>
<h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#e65c5c', fontFamily: 'Effra' }}>Contratos</h3>
{/* AHORA SÍ, AÑADIMOS EL CONTENEDOR CORRECTO */}
<div className="biblioteca-listbox-container">
<Listbox
value={ordenamientos.contratos}
onChange={(value) => setOrdenamientos({ ...ordenamientos, contratos: value })}
>
{({ open }) => (
<>
<ListboxButton className={`biblioteca-listbox-button ${open ? "open" : ""}`} style={{ minWidth: "150px" }}>
{opcionesOrdenamiento.find(op => op.value === ordenamientos.contratos).label}
<span className="biblioteca-arrow-container"><span className="biblioteca-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="biblioteca-listbox-options">
{opcionesOrdenamiento.map(opcion => (
<ListboxOption key={opcion.value} value={opcion.value} className="biblioteca-listbox-option">
{opcion.label}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
</div>
<div className="todos-archivos-grid" style={{ gap: '5px' }}>
{ordenarDocumentosPorTipo(contratos, ordenamientos.contratos).map((factura, index) => (
<FacturaCard key={index} factura={factura} isRecentCard={false} />
))}
</div>
</>
) : (
<p>No hay contratos en el repositorio.</p>
)}
{}
{facturasVenta.length > 0 ? (
<>
<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px', marginTop: '30px' }}>
<h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#e65c5c', fontFamily: 'Effra' }}>Facturas de venta</h3>
<div className="biblioteca-listbox-container">
<Listbox
value={ordenamientos.facturasVenta}
onChange={(value) => setOrdenamientos({ ...ordenamientos, facturasVenta: value })}
>
{({ open }) => (
<>
<ListboxButton className={`biblioteca-listbox-button ${open ? "open" : ""}`} style={{ minWidth: "150px" }}>
{opcionesOrdenamiento.find(op => op.value === ordenamientos.facturasVenta).label}
<span className="biblioteca-arrow-container"><span className="biblioteca-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="biblioteca-listbox-options">
{opcionesOrdenamiento.map(opcion => (
<ListboxOption key={opcion.value} value={opcion.value} className="biblioteca-listbox-option">
{opcion.label}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
</div>
<h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#777', marginTop: '20px' }}>Facturas A</h4>
{ordenarDocumentosPorTipo(facturasVentaA, ordenamientos.facturasVenta).length > 0 ? (
<div className="todos-archivos-grid" style={{ gap: '5px' }}>
{ordenarDocumentosPorTipo(facturasVentaA, ordenamientos.facturasVenta).map((factura, index) => (
<FacturaCard key={index} factura={factura} isRecentCard={false} />
))}
</div>
) : (
<p>No hay facturas A de venta.</p>
)}
<h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#777', marginTop: '20px' }}>Facturas B</h4>
{ordenarDocumentosPorTipo(facturasVentaB, ordenamientos.facturasVenta).length > 0 ? (
<div className="todos-archivos-grid" style={{ gap: '5px' }}>
{ordenarDocumentosPorTipo(facturasVentaB, ordenamientos.facturasVenta).map((factura, index) => (
<FacturaCard key={index} factura={factura} isRecentCard={false} />
))}
</div>
) : (
<p>No hay facturas B de venta.</p>
)}
<h4 style={{ fontSize: '14px', color: '#777', fontWeight: 'bold', marginTop: '20px' }}>Facturas X</h4>
{ordenarDocumentosPorTipo(facturasVentaX, ordenamientos.facturasVenta).length > 0 ? (
<div className="todos-archivos-grid" style={{ gap: '5px' }}>
{ordenarDocumentosPorTipo(facturasVentaX, ordenamientos.facturasVenta).map((factura, index) => (
<FacturaCard key={index} factura={factura} isRecentCard={false} />
))}
</div>
) : (
<p>No hay facturas X de venta.</p>
)}
</>
) : (
<p>No hay facturas de venta en el repositorio.</p>
)}
{}
{facturasCompra.length > 0 ? (
<>
<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px', marginTop: '30px' }}>
<h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#e65c5c', fontFamily: 'Effra' }}>Facturas de compra</h3>
{}
<div className="biblioteca-listbox-container" >
<Listbox
value={ordenamientos.facturasCompra}
onChange={(value) => setOrdenamientos({ ...ordenamientos, facturasCompra: value })}
>
{({ open }) => (
<>
<ListboxButton className={`biblioteca-listbox-button ${open ? "open" : ""}`} style={{ minWidth: "150px" }}>
{opcionesOrdenamiento.find(op => op.value === ordenamientos.facturasCompra).label}
<span className="biblioteca-arrow-container"><span className="biblioteca-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="biblioteca-listbox-options">
{opcionesOrdenamiento.map(opcion => (
<ListboxOption key={opcion.value} value={opcion.value} className="biblioteca-listbox-option">
{opcion.label}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
</div>
{ordenarDocumentosPorTipo(facturasCompraA, ordenamientos.facturasCompra).length > 0 && (
<>
<h4 style={{ fontSize: '14px', fontWeight: 'normal', color: '#777', fontWeight: 'bold', marginTop: '20px' }}>Facturas A</h4>
<div className="todos-archivos-grid" style={{ gap: '5px' }}>
{ordenarDocumentosPorTipo(facturasCompraA, ordenamientos.facturasCompra).map((factura, index) => (
<FacturaCard key={index} factura={factura} isRecentCard={false} />
))}
</div>
</>
)}
{ordenarDocumentosPorTipo(facturasCompraB, ordenamientos.facturasCompra).length > 0 && (
<>
<h4 style={{ fontSize: '14px', color: '#777', fontWeight: 'bold', marginTop: '20px' }}>Facturas B</h4>
<div className="todos-archivos-grid" style={{ gap: '5px' }}>
{ordenarDocumentosPorTipo(facturasCompraB, ordenamientos.facturasCompra).map((factura, index) => (
<FacturaCard key={index} factura={factura} isRecentCard={false} />
))}
</div>
</>
)}
{ordenarDocumentosPorTipo(facturasCompraC, ordenamientos.facturasCompra).length > 0 && (
<>
<h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#777', marginTop: '20px' }}>Facturas C</h4>
<div className="todos-archivos-grid" >
{ordenarDocumentosPorTipo(facturasCompraC, ordenamientos.facturasCompra).map((factura, index) => (
<FacturaCard key={index} factura={factura} isRecentCard={false} />
))}
</div>
</>
)}
{ordenarDocumentosPorTipo(facturasCompraX, ordenamientos.facturasCompra).length > 0 && (
<>
<h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#777', marginTop: '20px' }}>Facturas X</h4>
<div className="todos-archivos-grid" >
{ordenarDocumentosPorTipo(facturasCompraX, ordenamientos.facturasCompra).map((factura, index) => (
<FacturaCard key={index} factura={factura} isRecentCard={false} />
))}
</div>
</>
)}
</>
) : (
<p>No hay facturas de compra en el repositorio.</p>
)}
</>
) : (
<div style={{ marginTop: '20px' }}>
<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px', marginBottom: '15px' }}>
<div className="biblioteca-listbox-container">
<Listbox
value={ordenamientos.contratos}
onChange={(value) => setOrdenamientos({ ...ordenamientos, contratos: value })}
>
{({ open }) => (
<>
<ListboxButton className={`biblioteca-listbox-button ${open ? "open" : ""}`} style={{ minWidth: "150px" }}>
{opcionesOrdenamiento.find(op => op.value === ordenamientos.contratos).label}
<span className="biblioteca-arrow-container"><span className="biblioteca-arrow"></span></span>
</ListboxButton>
<ListboxOptions className="biblioteca-listbox-options">
{opcionesOrdenamiento.map(opcion => (
<ListboxOption key={opcion.value} value={opcion.value} className="biblioteca-listbox-option">
{opcion.label}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
</div>
<div className="todos-archivos-grid" style={{ gap: '5px' }}>
{ordenarDocumentosPorTipo(documentosFiltrados, ordenamientos.contratos).length > 0 ? (
ordenarDocumentosPorTipo(documentosFiltrados, ordenamientos.contratos).map((factura, index) => (
<FacturaCard key={index} factura={factura} isRecentCard={false} />
))
) : (
<p style={{ marginTop: '20px' }}>No se encontraron archivos con este filtro.</p>
)}
</div>
</div>
)}
</div>
</div>
)}
<RepositorioModal
show={showFacturaModal}
archivo={archivoSeleccionado}
archivoForm={facturaForm}
handleChange={(e) =>
setFacturaForm({ ...facturaForm, [e.target.name]: e.target.value })
}
handleTipoChange={(value) =>
setFacturaForm({ ...facturaForm, tipo: value })
}
opcionesTipoFactura={opcionesTipoFactura}
handleSubmit={handleFacturaModalSubmit}
onClose={() => {
setShowFacturaModal(false);
setArchivoSeleccionado(null);
setFacturaForm({ titulo: "", parte_interesada: "", descripcion: "" });
}}
subiendo={subiendo}
/>
</div>
);
};

export default Repositorio;
